import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { ContactoDetalle } from '../model/classes/contacto.class';

@Injectable()
export class ContactosService {
    constructor(private http: Http) { }
    private contactosUrl = 'api/contactos';
    private contactoUrl = 'api/contacto';
    getContactos(codSistema: string, codNegocio: string): Promise<ContactoDetalle[]> {
        let parametros = new URLSearchParams();
        parametros.set('codSistema', codSistema);
        parametros.set('codNegocio', codNegocio);
        return this.http.get(this.contactosUrl, { search: parametros })
            .toPromise()
            .then(response => response.json().data as ContactoDetalle[])
            .catch(this.handleError);
    }
    getContacto(id: string): Promise<ContactoDetalle> {
        return this.http.get(this.contactoUrl + '/' + id)
            .toPromise()
            .then(response => response.json().data as ContactoDetalle)
            .catch(this.handleError);
    }
    // agregarContacto(id: string): Promise<ContactoDetalle> {
    //     return this.http.put(this.contactoUrl + "/" + id)
    //         .toPromise()
    //         .then(response => response.json().data as ContactoDetalle)
    //         .catch(this.handleError);
    // }
    // actualizarContacto(id: string): Promise<ContactoDetalle> {
    //     return this.http.post(this.contactoUrl + "/" + id)
    //         .toPromise()
    //         .then(response => response.json().data as ContactoDetalle)
    //         .catch(this.handleError);
    // }

    private handleError(error: any): Promise<any> {
        console.error('Ocurrió un error', error);
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/contactos.service.ts